'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RightArrowCircled = require('./RightArrowCircled');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RightArrowCircled).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/RightArrowCircled/index.js
// module id = 1278
// module chunks = 1